export function postMessageToIframe(data: any) {
    const test = document.getElementsByClassName('da-iframe');
    if (test.length === 0) {
        console.error('iframe not found');
        return;
    }

    const iframe = test[0].getElementsByTagName('iframe')[0];
    if (!iframe) {
        console.error('iframe not found');
        return;
    }

    const url = new URL(iframe.src).origin;
    const win = iframe;
    const iframeElement = eval('(win.contentWindow || win.contentDocument)');
    iframeElement.postMessage(JSON.stringify(data), url);
}